import angular from 'angular';

angular.module('checkout').directive(
    'cartSummaryText', [
        '$sce',
        'orderMgr',
        function (
            $sce,
            orderMgr
        ) {
            function link(scope) {
                scope.itemQuantity = '';
                scope.orderItems = [];

                orderMgr.getEventManager().on(
                    'orderMgr.orderChange',
                    function (order) {
                        scope.orderItems = order.items;
                        scope.itemQuantity = order.itemCount;
                    },
                    'cartDisplayIcon'
                );

                if (!orderMgr.hasOrder()) {
                    orderMgr.refreshOrder();
                } else {
                    var order = orderMgr.getOrder();
                    scope.orderItems = order.items;
                    scope.itemQuantity = order.itemCount;
                }
            }

            return {
                link: link,
                restrict: 'E', // element name
                scope: {
                    propsDisplayText: '=displayText',
                },
                template: `
                    <style type="text/css">
                    .reliv-cart-summary {
                        position: relative;
                    }

                    .reliv-cart-summary-text a,
                    .reliv-cart-summary-text a:hover,
                    .reliv-cart-summary-text a:visited,
                    .reliv-cart-summary-text a:active {
                        text-decoration: none;
                    }

                    </style>
                    <div class="reliv-cart-summary-text">
                        <a href="/cart#/items">
                            <div class="cart-text">{{propsDisplayText|translate}} <span class="cart-text-count" ng-if="itemQuantity.length !== 0 && itemQuantity != 0">{{itemQuantity}}</span></div>
                        </a>
                        <cart-summary-items order-items="orderItems"></cart-summary-items>
                    </div>
                `,
            };
        },
    ]
);
